<template>
  <div class="card">
    <div class="title-box">{{ data.name }}</div>
    <div class="data-box">
      <div class="dialogs-limit-box data-item">
        <div class="label">Dialogues Limit</div>
        <div class="data">{{ data.dialogsLimit }}</div>
      </div>
      <div class="recodings-limit-box data-item">
        <div class="label">Recodings Limit</div>
        <div class="data">{{ data.recordingsLimit }}</div>
      </div>
      <div class="recordings-storage-box data-item">
        <div class="label">Recordings Storage</div>
        <div class="data">{{ data.recordingsStorage }}</div>
      </div>
    </div>
    <div class="bottom-box">
      <div class="date-box">
        <div class="label">End of plan:</div>
        <div class="value">{{ getEndDate }}</div>
      </div>
      <button @click="usePlan">Use Plan</button>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import alert from '@/lib/alert'

export default {
  name: 'PlanCard',
  props: {
    data: Object
  },
  methods: {
    usePlan() {
      axios({
        method: 'post',
        url: `${process.env.VUE_APP_SERVER_URL}usePromoCode`,
        headers: {
          Authorization: 'Bearer ' + localStorage.getItem('token'),
        },
        data: {
          planId: this.data._id
        }
      }).then(() => {
        alert.showSuccess('Plan Added');
        this.onReload();
      }).catch(err => {
        alert.showError(err.response.data.error);
      })
    },
    onReload() {
      this.$emit('reload');
    }
  },
  computed: {
    getEndDate() {
      let date = new Date(this.data.expiration * 86400000 + Date.now());
      let day = date.getDate();
      let month = date.getMonth();
      let year = date.getFullYear();
      let monthArray = new Array();
      monthArray[0] = "January";
      monthArray[1] = "February";
      monthArray[2] = "March";
      monthArray[3] = "April";
      monthArray[4] = "May";
      monthArray[5] = "June";
      monthArray[6] = "July";
      monthArray[7] = "August";
      monthArray[8] = "September";
      monthArray[9] = "October";
      monthArray[10] = "November";
      monthArray[11] = "December";
      return `${day} ${monthArray[month]} ${year}`;
    }
  }
}
</script>

<style lang="scss" scoped>
.card {
  width: 90%;
  height: auto;
  background-color: #a7ddd8;
  display: flex;
  flex-direction: column;

  .title-box {
    width: 100%;
    height: 5rem;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 1.3rem;
    font-weight: bold;
    background-color: #10a193;
    text-transform: capitalize;
    color: white;
  }

  .data-box {
    width: 100%;
    height: auto;
    display: flex;
    margin-top: 2rem;
    margin-bottom: 2rem;

    .data-item {
      flex: 1;
      display: flex;
      flex-direction: column;
      .label {
        height: 2.5rem;
        display: flex;
        justify-content: center;
        align-items: center;
        font-weight: bold;
        font-size: 1rem;
        color: rgb(58, 58, 58);
        text-align: center;
      }
      .data {
        height: 2.5rem;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 1.1rem;
        color: rgb(58, 58, 58);
      }
    }
  }

  .bottom-box {
    width: 100%;
    height: 5rem;
    display: flex;
    justify-content: space-evenly;
    align-items: center;

    @media (max-width: 600px) {
      flex-direction: column;
      justify-content: space-around;
      height: 8rem;
    }

    .date-box {
      width: auto;
      height: auto;
      display: flex;

      .label {
        font-weight: bold;
        padding-right: 0.5rem;
      }
    }

    button {
      width: 12rem;
      height: 2.8rem;
      font-size: 1rem;
      background-color: #10a192ce;
      color: white;
      border: none;
      transition: 0.2s;
      outline: none;

      &:hover {
        cursor: pointer;
        background-color: #10a193;
      }
    }
  }
}
</style>